import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { calculateAverageRating } from "../../Helpers/calculateAverageRating";
import { useTranslation } from "react-i18next";
import { MatchLocationToCurrency } from "../../main-component/Extensions/MatchLocationToCurrency";
import './Styles/BookCard.css';
import '../hero/style/mobile-app-banner.css';
import GoogleTag from "../../Extensions/GoogleTag";
import { useGetAllCategoriesQuery } from "../../api/categoryApi";
import { useGetFilteredCoursesMutation } from "../../api/courseApi";

// Mobil uygulama banner bileşeni - Sade tasarım
const MobileAppBanner = () => {
  return (
    <div style={{
      background: 'rgba(255, 251, 243, 0.92)',
      padding: '1.75rem 2rem',
      borderRadius: '8px',
      marginBottom: '1.5rem',
      border: '1px solid rgba(110, 90, 66, 0.2)',
      boxShadow: '0 18px 46px rgba(58, 45, 34, 0.1)',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: '1.5rem',
      flexWrap: 'wrap'
    }}>
      <div style={{ flex: '1', minWidth: '240px' }}>
        <h3 style={{ color: '#2d241b', fontFamily: 'Georgia, Times New Roman, serif', fontSize: '1.75rem', lineHeight: '1.05', marginBottom: '0.55rem', fontWeight: '500', letterSpacing: '0' }}>
          LearningHell Mobil Uygulaması
        </h3>
        <p style={{ color: '#6f665a', fontSize: '0.95rem', marginBottom: '1rem', maxWidth: '420px' }}>
          Eğitimlerinize her an her yerden ulaşın. Hemen indirin!
        </p>
        <a 
          href="https://play.google.com/store/apps/details?id=com.fayik.LH&hl=en" 
          target="_blank" 
          rel="noopener noreferrer"
          aria-label="Google Play'den indir"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.6rem 1.25rem',
            background: '#2f4f40',
            color: 'white',
            borderRadius: '6px',
            textDecoration: 'none',
            fontWeight: '600',
            fontSize: '0.9rem',
            transition: 'opacity 0.2s ease'
          }}
        >
          <svg viewBox="0 0 24 24" style={{ width: '20px', height: '20px', fill: 'currentColor' }}>
            <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
          </svg>
          <span>Google Play'den İndir</span>
        </a>
      </div>
      <div style={{ display: 'flex', gap: '0.75rem' }}>
        <img 
          src="/BannerPictures/Adsız tasarım (5).png" 
          alt="LearningHell Mobil Uygulama"
          style={{ width: '100px', borderRadius: '8px', border: '1px solid rgba(110, 90, 66, 0.18)' }}
        />
        <img 
          src="/BannerPictures/Adsız tasarım (6).png" 
          alt="LearningHell Mobil Uygulama" 
          style={{ width: '100px', borderRadius: '8px', border: '1px solid rgba(110, 90, 66, 0.18)' }}
        />
      </div>
    </div>
  );
};

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

// Basit Kurs Kartı Bileşeni
const BookCard = React.memo(({ course }) => {
  const rating = useMemo(() => calculateAverageRating(course.ratings), [course.ratings]);

  return (
    <Link
      onClick={ClickHandler}
      to={`/course-single/${course.courseId}`}
      aria-label={`View course: ${course.courseName}`}
      style={{ textDecoration: 'none' }}
    >
      <div className="book-card">
        <div className="book-card-inner">
          <div className="book-cover">
            <img 
              src={course.courseImage} 
              alt={`${course.courseName} cover`}
              className="book-image"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = 'https://via.placeholder.com/400x300?text=Course+Image';
              }}
              loading="lazy"
            />
            
            {course.coursePrice === "0" || course.coursePrice === 0 ? (
              <div className="book-free-badge">ÜCRETSİZ</div>
            ) : (
              <div className="book-price-badge">
                {MatchLocationToCurrency()}{course.coursePrice}
              </div>
            )}
            
            <div className="book-content">
              <div className="book-card-meta">
                <span>Kurs</span>
                <span>{course.lesson ? `${course.lesson} Ders` : 'Ders içerikleri'}</span>
              </div>
              <h3 className="book-title">{course.courseName}</h3>
              
              <div className="book-rating">
                <div className="book-stars">
                  {[...Array(5)].map((_, i) => (
                    <i 
                      key={i} 
                      className={`fi flaticon-star book-star ${i < Math.floor(rating) ? 'filled' : ''}`}
                    ></i>
                  ))}
                </div>
                <span className="book-rating-text">({rating})</span>
              </div>
              
              <div className="book-stats">
                <span className="book-stat">
                  <i className="fi flaticon-reading-book"></i>
                  {course.student || 0} Öğrenci
                </span>
                <span className="book-stat">
                  <i className="fi flaticon-agenda"></i>
                  Detayları incele
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
});

// Filtreleme Sidebar Bileşeni
const FilterSidebar = ({ onFilterChange }) => {
  const { t } = useTranslation();
  const { data: categoriesData } = useGetAllCategoriesQuery();
  const [filters, setFilters] = useState({
    searchText: '',
    categoryId: '',
    minPrice: '',
    maxPrice: '',
    sortBy: 'name'
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const handleApplyFilters = () => {
    onFilterChange(filters);
  };

  const handleResetFilters = () => {
    const resetFilters = {
      searchText: '',
      categoryId: '',
      minPrice: '',
      maxPrice: '',
      sortBy: 'name'
    };
    setFilters(resetFilters);
    onFilterChange(resetFilters);
  };

  return (
    <div className="filter-sidebar">
      <h3>
        <i className="fi flaticon-filter"></i> Filtrele
      </h3>
      
      <div className="filter-group">
        <label>Kurs Ara</label>
        <input
          type="text"
          name="searchText"
          value={filters.searchText}
          onChange={handleInputChange}
          placeholder="Kurs adı yazın..."
          className="filter-input"
        />
      </div>
      
      <div className="filter-group">
        <label>Kategori</label>
        <select
          name="categoryId"
          value={filters.categoryId}
          onChange={handleInputChange}
          className="filter-select"
        >
          <option value="">Tüm Kategoriler</option>
          {categoriesData?.result?.map(cat => (
            <option key={cat.categoryId} value={cat.categoryId}>
              {cat.categoryName}
            </option>
          ))}
        </select>
      </div>
      
      <div className="filter-group">
        <label>Fiyat Aralığı</label>
        <div className="price-range-container">
          <input
            type="number"
            name="minPrice"
            value={filters.minPrice}
            onChange={handleInputChange}
            placeholder="Min"
            className="filter-input price-input"
          />
          <input
            type="number"
            name="maxPrice"
            value={filters.maxPrice}
            onChange={handleInputChange}
            placeholder="Max"
            className="filter-input price-input"
          />
        </div>
      </div>
      
      <div className="filter-group">
        <label>Sıralama</label>
        <select
          name="sortBy"
          value={filters.sortBy}
          onChange={handleInputChange}
          className="filter-select"
        >
          <option value="name">İsme Göre (A-Z)</option>
          <option value="name_desc">İsme Göre (Z-A)</option>
          <option value="price_asc">Fiyat (Düşük-Yüksek)</option>
          <option value="price_desc">Fiyat (Yüksek-Düşük)</option>
          <option value="popular">Popülerlik</option>
        </select>
      </div>
      
      <div className="filter-buttons">
        <button className="filter-btn apply-filter" onClick={handleApplyFilters}>
          Uygula
        </button>
        <button className="filter-btn reset-filter" onClick={handleResetFilters}>
          Temizle
        </button>
      </div>
    </div>
  );
};

const CourseSection = (props) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [courses, setCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [getFilteredCourses, { isLoading: isFiltering }] = useGetFilteredCoursesMutation();

  useEffect(() => {
    if (props.popularCourses) {
      setCourses(props.popularCourses);
      setFilteredCourses(props.popularCourses);
      setIsLoading(false);
    }
  }, [props.popularCourses]);

  const handleFilterChange = async (filters) => {
    setIsLoading(true);
    
    // Eğer tüm filtreler boşsa, orijinal listeyi göster
    const isEmptyFilter = !filters.searchText && !filters.categoryId && 
                          !filters.minPrice && !filters.maxPrice;
    
    if (isEmptyFilter) {
      setFilteredCourses(courses);
      setIsLoading(false);
      return;
    }

    try {
      // Backend'e filtreleme isteği gönder
      const result = await getFilteredCourses(filters).unwrap();
      
      if (result && result.result) {
        setFilteredCourses(result.result);
      } else {
        setFilteredCourses([]);
      }
    } catch (error) {
      console.error('Filter error:', error);
      
      // Backend hatası durumunda frontend'de filtrele
      let filtered = [...courses];
      
      if (filters.searchText) {
        filtered = filtered.filter(course => 
          course.courseName.toLowerCase().includes(filters.searchText.toLowerCase()) ||
          (course.courseDescription && course.courseDescription.toLowerCase().includes(filters.searchText.toLowerCase()))
        );
      }
      
      if (filters.categoryId) {
        filtered = filtered.filter(course => 
          course.categoryId === filters.categoryId
        );
      }
      
      if (filters.minPrice) {
        filtered = filtered.filter(course => 
          parseFloat(course.coursePrice) >= parseFloat(filters.minPrice)
        );
      }
      
      if (filters.maxPrice) {
        filtered = filtered.filter(course => 
          parseFloat(course.coursePrice) <= parseFloat(filters.maxPrice)
        );
      }
      
      // Sıralama
      switch (filters.sortBy) {
        case 'name':
          filtered.sort((a, b) => a.courseName.localeCompare(b.courseName));
          break;
        case 'name_desc':
          filtered.sort((a, b) => b.courseName.localeCompare(a.courseName));
          break;
        case 'price_asc':
          filtered.sort((a, b) => parseFloat(a.coursePrice) - parseFloat(b.coursePrice));
          break;
        case 'price_desc':
          filtered.sort((a, b) => parseFloat(b.coursePrice) - parseFloat(a.coursePrice));
          break;
        case 'popular':
          filtered.sort((a, b) => (b.student || 0) - (a.student || 0));
          break;
        default:
          break;
      }
      
      setFilteredCourses(filtered);
    }
    
    setIsLoading(false);
  };

  return (
    <>
      <GoogleTag/>
      <div style={{ background: 'linear-gradient(90deg, rgba(47, 79, 64, 0.05) 1px, transparent 1px), linear-gradient(0deg, rgba(47, 79, 64, 0.045) 1px, transparent 1px), linear-gradient(135deg, #f7f0e4 0%, #efe2cf 100%)', backgroundSize: '34px 34px, 34px 34px, auto', minHeight: '100vh', paddingTop: '1.5rem' }}>
        {/* Mobil Uygulama Banner */}
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1.5rem' }}>
          <MobileAppBanner />
        </div>
        
        {/* Ana İçerik */}
        <div className="book-cards-container">
          {/* Sol Filtreleme Sidebar */}
          <FilterSidebar onFilterChange={handleFilterChange} />
          
          {/* Kurslar Grid */}
          <div className="courses-grid">
            {isLoading || isFiltering ? (
              <div className="books-loading">
                <div className="book-loader"></div>
              </div>
            ) : filteredCourses && filteredCourses.length > 0 ? (
              filteredCourses.map((course, index) => (
                <BookCard key={course.courseId || index} course={course} />
              ))
            ) : (
              <div className="no-courses">
                <i className="fi flaticon-search"></i>
                <p>Aradığınız kriterlere uygun kurs bulunamadı.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(CourseSection);
